import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { TextFieldWithAddon } from '../../../ui/FormElement';

function OnetimeDiscount(props) {
  const { isDisabled, ...rest } = props;

  const {
    values: { onetime_discount_enable },
    setFieldValue,
  } = useFormikContext();

  useEffect(() => {
    if (!onetime_discount_enable) {
      setFieldValue('onetime_discount', '');
    }
  }, [onetime_discount_enable]);

  return (
    <TextFieldWithAddon
      disabled={!onetime_discount_enable || isDisabled}
      name="onetime_discount"
      type="number"
      addon="%"
      min="0"
      step="0.01"
      pattern="d+(.d{1,2})?"
      {...rest}
    />
  );
}

export default OnetimeDiscount;
